import {
  type OfferPriceV1,
  type OfferV11,
  PrescriptionV3PrescriptionTypeEnum,
} from '@redteclab/api/clients/bully'

export const priceAccessorGetDisplayPrice = (
  offer: OfferV11,
  prescriptionType: PrescriptionV3PrescriptionTypeEnum,
): OfferPriceV1 | null => {
  if (prescriptionType === PrescriptionV3PrescriptionTypeEnum.NoPrescription) {
    return offer.offerPrice ?? null
  }

  return offer.prescriptionPriceMap?.[prescriptionType] ?? null
}
